import PiloeerLogo from '@/assets/logo.svg?react';
import { EXTERNAL_LINKS } from '@/constants/external-links';
import { Button } from '@/ui/@components/primitives/button';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from '@/ui/@components/primitives/sheet';
import { useUserRole } from '@/ui/@hooks/use-user-role';
import { APP_ROUTES } from '@/ui/application-routes';
import { isActiveRoute } from '@/utils/nav';
import { cn } from '@/utils/tailwind';
import { LifeBuoy, PanelLeft } from 'lucide-react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { getDashNavigationSections } from '../../dash-navigation';

export const MobileSheet: FunctionComponent = () => {
  const { role: userRole } = useUserRole();
  const { t } = useTranslation();
  const navSections = getDashNavigationSections({ role: userRole, t });

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button size='icon' variant='outline' className='md:hidden'>
          <PanelLeft className='h-5 w-5' />
          <span className='sr-only'>Toggle Menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side='left' className='sm:max-w-xs'>
        <nav className='grid gap-6 text-base font-medium'>
          <Link
            to={
              userRole === 'coach'
                ? APP_ROUTES.COACH.MAIN
                : APP_ROUTES.DASHBOARD
            }
            className='group flex h-10 items-center gap-3 text-lg font-semibold text-foreground md:text-base'
          >
            <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary text-primary-foreground'>
              <PiloeerLogo className='h-6 w-6 transition-all group-hover:scale-110' />
            </span>
            <span>Piloteer</span>
          </Link>
          {navSections.map((section) => (
            <div
              key={
                section.label ?? section.items.map((item) => item.to).join('-')
              }
              className={cn('space-y-2', section.separator && 'border-t pt-4')}
            >
              {section.label && (
                <div className='px-2.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground'>
                  {section.label}
                </div>
              )}
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className={cn(
                      'flex h-10 items-center gap-3 rounded-md px-2.5 text-muted-foreground',
                      isActiveRoute(item.to, item.activeRoutes) &&
                        'bg-muted text-foreground'
                    )}
                  >
                    <Icon className='h-5 w-5 shrink-0' />
                    <span className='truncate'>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ))}
          <Link
            to={EXTERNAL_LINKS.SUPPORT_EMAIL}
            className='flex h-10 items-center gap-3 rounded-md px-2.5 text-muted-foreground'
          >
            <LifeBuoy className='h-5 w-5 shrink-0' />
            {t('nav.support')}
          </Link>
        </nav>
      </SheetContent>
    </Sheet>
  );
};
